module.exports = __webpack_public_path__ + "static/media/cases_web_keslon_03b.dc62d815.jpg";